import useSWR from 'swr';
import { useDebounce } from 'usehooks-ts';

import fetcher from 'lib/fetcher';
import useBoundStore from 'store';
import { AppMode } from 'hooks/use-app-mode';
import { APIApartmentComplexBuilding } from 'api/types';
import { ISelectItem } from 'lib/types';
import { sortByTitle } from 'lib/utils';

export type TComplexes = {
  id: number;
  title: string;
  buildings: APIApartmentComplexBuilding[];
};

export type APIApartmentComplexSearchRes = {
  complexes: TComplexes[];
};

const useApartmentComplexSearch = (
  appMode: AppMode,
  isTransformForSelect?: boolean,
  isFetch: boolean = true,
) => {
  const search = useBoundStore((s) =>
    appMode === 'buy' ? s.buyApartmentSearch : s.sellApartmentSearch,
  );
  const debouncedSearch = useDebounce(search, 600);

  const { data, error, isLoading, mutate } = useSWR<APIApartmentComplexSearchRes>(
    `/apartment-complexes/search?titleSubstring=${debouncedSearch}`,
    isFetch ? fetcher.swr : null,
  );

  const transformData = (dataRes: APIApartmentComplexSearchRes | undefined): ISelectItem[] => {
    if (dataRes) {
      const dataTransformed = dataRes?.complexes?.map((item) => ({
        key: item.id,
        label: item.title,
      }));

      return sortByTitle(dataTransformed) as ISelectItem[];
    }
    return [];
  };

  return {
    complexes: isTransformForSelect ? transformData(data) : data?.complexes ?? [],
    error,
    isLoading,
    mutate
  };
};

export default useApartmentComplexSearch;
